var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Dropdown } from '@leapfinance/geebee-component-library';
import classNames from 'classnames';
import CustomPopper from './CustomPopper';
import useCFFilters from './useCFFilters';
var StudentNationalityFilter = function (props) {
    var studentNationality = useCFFilters({}).studentNationality;
    var _a = __read(useState(false), 2), open = _a[0], setOpen = _a[1];
    return (React.createElement(Dropdown, { open: open, onClose: function () {
            setOpen(false);
        }, onOpen: function () {
            setOpen(true);
        }, disableClearable: true, size: "small", blurOnSelect: true, className: classNames(' lfc-transition-all lfc-w-[190px]'
        // { 'lfc-w-[190px]': !inFocus }
        // { 'lfc-w-[250px]': inFocus },
        ), textInputProps: {
            label: 'Student Nationality',
            placeholder: 'Select Student Nationality',
            keepDefaultLabelBehaviour: true,
            InputProps: {
                sx: function (theme) {
                    var _a, _b, _c, _d, _e;
                    return !open
                        ? {
                            '&.MuiOutlinedInput-root': {
                                color: (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a['500'],
                                backgroundColor: (_b = theme.palette.primary) === null || _b === void 0 ? void 0 : _b['200'],
                                fieldSet: {
                                    borderColor: (_c = theme.palette.primary) === null || _c === void 0 ? void 0 : _c['500']
                                },
                                ':hover': {
                                    backgroundColor: (_d = theme.palette.primary) === null || _d === void 0 ? void 0 : _d['200']
                                    // fieldSet: {
                                    //   borderColor: theme.palette.primary?.['500']
                                    // }
                                },
                                '.MuiInputAdornment-positionStart': {
                                    '.MuiTypography-root': {
                                        color: (_e = theme.palette.primary) === null || _e === void 0 ? void 0 : _e['500']
                                    }
                                },
                                input: {
                                    textOverflow: 'ellipsis'
                                }
                            }
                        }
                        : {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: 'white'
                            }
                        };
                }
            }
        }, value: studentNationality !== null && studentNationality !== void 0 ? studentNationality : props === null || props === void 0 ? void 0 : props.defaultStudentNationality, options: props.countryOptions, 
        //   getOptionDisabled={disabledOption}
        onChange: function (_event, value) {
            props === null || props === void 0 ? void 0 : props.handleFilterApply({ name: props === null || props === void 0 ? void 0 : props.name, value: value !== null && value !== void 0 ? value : props === null || props === void 0 ? void 0 : props.defaultStudentNationality });
        }, PopperComponent: CustomPopper }));
};
export default StudentNationalityFilter;
//# sourceMappingURL=StudentNationalityFilter.js.map